import React, { useContext } from "react";
import TextField from '@material-ui/core/TextField'

import RenderError from '../render-error'

import DonationFormContext from '../../context/donation'

interface PricepointsProps {
  [key: string]: any
}

const Pricepoints: React.FC<PricepointsProps> = (props: any) => {

  const donationForm = useContext(DonationFormContext)
  const appeal = (window as any).KEW.collections.appeal[0]

  return (
    <>
      <div className="row">
        <div className="price-points clearfix">
          <div className="large-12 columns">
            { !donationForm.paramAmount && appeal.gift_array_active &&
              <h2 className="text-center robo-m" id="donation-amount-label">How much would you like to give?</h2>
            }
            { (donationForm.paramAmount || !appeal.gift_array_active) &&
              <h2 className="text-center robo-m" id="donation-amount-label">Your donation amount?</h2>
            }
            { (props.values.payment_type === 'Single' && appeal.single_active && appeal.gift_array_active && !donationForm.paramAmount) &&
              <>
                <fieldset aria-labelledby="donation-amount-label">

                  <div className={`medium-4 columns price-point pp1 ${appeal.single_pp1 === props.values.amount ? 'active' : ''}`}>
                    <input
                      className="visuallyhidden"
                      type="radio"
                      id="gift-array-1"
                      value={appeal.single_pp1}
                      name="price-point-select"
                      onClick={() => {
                        props.setFieldValue('amount', appeal.single_pp1)
                      }}
                      onKeyPress={() => {
                        props.setFieldValue('amount', appeal.single_pp1)
                      }} />
                    <label
                      htmlFor="gift-array-1"
                      className={`medium-4 columns price-point pp1`}>
                      £{appeal.single_pp1}
                    </label>
                  </div>

                  <div className={`medium-4 columns price-point pp2 ${appeal.single_pp2 === props.values.amount ? 'active' : ''}`}>
                    <input
                      className="visuallyhidden"
                      type="radio"
                      id="gift-array-2"
                      value={appeal.single_pp2}
                      name="price-point-select"
                      onClick={() => {
                        props.setFieldValue('amount', appeal.single_pp2)
                      }}
                      onKeyPress={() => {
                        props.setFieldValue('amount', appeal.single_pp2)
                      }} />
                    <label
                      htmlFor="gift-array-2"
                      className={`medium-4 columns price-point pp2`}>
                      £{appeal.single_pp2}
                    </label>
                  </div>

                  <div className={`medium-4 columns price-point pp3 ${appeal.single_pp3 === props.values.amount ? 'active' : ''}`}>
                    <input
                      className="visuallyhidden"
                      type="radio"
                      id="gift-array-3"
                      value={appeal.single_pp3}
                      name="price-point-select"
                      onClick={() => {
                        props.setFieldValue('amount', appeal.single_pp3)
                      }}
                      onKeyPress={() => {
                        props.setFieldValue('amount', appeal.single_pp3)
                      }} />
                    <label
                      htmlFor="gift-array-3"
                      className={`medium-4 columns price-point pp3`}>
                      £{appeal.single_pp3}
                    </label>
                  </div>

                </fieldset>

              </>
            }
            { (props.values.payment_type === 'Regular' && appeal.regular_active && appeal.gift_array_active && !donationForm.paramAmount) &&

              <fieldset aria-labelledby="donation-amount-label">

                <div className={`medium-4 columns price-point pp1 ${appeal.regular_pp1 === props.values.amount ? 'active' : ''}`}>
                  <input
                    className="visuallyhidden"
                    type="radio"
                    id="gift-array-1"
                    value={appeal.regular_pp1}
                    name="price-point-select"
                    onClick={() => {
                      props.setFieldValue('amount', appeal.regular_pp1)
                    }}
                    onKeyPress={() => {
                      props.setFieldValue('amount', appeal.regular_pp1)
                    }} />
                  <label
                    htmlFor="gift-array-1"
                    className={`medium-4 columns price-point pp1`}>
                    £{appeal.regular_pp1}<span>per month</span>
                  </label>
                </div>

                <div className={`medium-4 columns price-point pp2 ${appeal.regular_pp2 === props.values.amount ? 'active' : ''}`}>
                  <input
                    className="visuallyhidden"
                    type="radio"
                    id="gift-array-2"
                    value={appeal.regular_pp2}
                    name="price-point-select"
                    onClick={() => {
                      props.setFieldValue('amount', appeal.regular_pp2)
                    }}
                    onKeyPress={() => {
                      props.setFieldValue('amount', appeal.regular_pp2)
                    }} />
                  <label
                    htmlFor="gift-array-2"
                    className={`medium-4 columns price-point pp2`}>
                    £{appeal.regular_pp2}<span>per month</span>
                  </label>
                </div>

                <div className={`medium-4 columns price-point pp3 ${appeal.regular_pp3 === props.values.amount ? 'active' : ''}`}>
                  <input
                    className="visuallyhidden"
                    type="radio"
                    id="gift-array-3"
                    value={appeal.regular_pp3}
                    name="price-point-select"
                    onClick={() => {
                      props.setFieldValue('amount', appeal.regular_pp3)
                    }}
                    onKeyPress={() => {
                      props.setFieldValue('amount', appeal.regular_pp3)
                    }} />
                  <label
                    htmlFor="gift-array-3"
                    className={`medium-4 columns price-point pp3`}>
                    £{appeal.regular_pp3}<span>per month</span>
                  </label>
                </div>

              </fieldset>

              // <div className="pp-single clearfix">
              //   <div className={`medium-4 columns price-point pp1 ${appeal.regular_pp1 === props.values.amount ? 'active' : ''}`} id="gift-array-1">
              //     <span
              //       className="text-center"
              //       style={ appeal.regular_pp1 === props.values.amount ? { backgroundImage: `url(${appeal.active_pp_image})`} : {}}
              //         onClick={() => {
              //           props.setFieldValue('amount', appeal.regular_pp1)
              //         }}
              //         onKeyPress={() => {
              //           props.setFieldValue('amount', appeal.regular_pp1)
              //         }}
              //         tabIndex={0}>
              //       £{appeal.regular_pp1}<span>per month</span>
              //     </span>
              //   </div>
              //   <div className={`medium-4 columns price-point pp2 ${appeal.regular_pp2 === props.values.amount ? 'active' : ''}`} id="gift-array-2">
              //     <span
              //       className="text-center"
              //       style={ appeal.regular_pp2 === props.values.amount ? { backgroundImage: `url(${appeal.active_pp_image})`} : {}}
              //         onClick={() => {
              //           props.setFieldValue('amount', appeal.regular_pp2)
              //         }}
              //         onKeyPress={() => {
              //           props.setFieldValue('amount', appeal.regular_pp2)
              //         }}
              //         tabIndex={0}>
              //       £{appeal.regular_pp2}<span>per month</span>
              //     </span>
              //   </div>
              //   <div className={`medium-4 columns price-point pp3 ${appeal.regular_pp3 === props.values.amount ? 'active' : ''}`} id="gift-array-3">
              //     <span
              //       className="text-center"
              //       style={ appeal.regular_pp3 === props.values.amount ? { backgroundImage: `url(${appeal.active_pp_image})`} : {}}
              //         onClick={() => {
              //           props.setFieldValue('amount', appeal.regular_pp3)
              //         }}
              //         onKeyPress={() => {
              //           props.setFieldValue('amount', appeal.regular_pp3)
              //         }}
              //         tabIndex={0}>
              //       £{appeal.regular_pp3}<span>per month</span>
              //     </span>
              //   </div>
              // </div>
            }
            <div className="large-12 columns"></div>
            <div className="amount-input">
              { appeal.gift_array_active && !donationForm.paramAmount &&
                <label htmlFor="donation-amount">or change to your own amount:</label>
              }
              <div className="amount-input">
                <span className="currency-symbol">£</span>
                <TextField
                  type="number"
                  variant="outlined"
                  id="donation-amount"
                  name="amount"
                  inputProps={{
                    "aria-describedby": "donation-amount_error"
                  }}
                  error={props.errors.amount ? true : false}
                  value={props.values.amount}
                  onClick={() => props.setFieldValue('amount', '')}
                  onChange={props.handleChange} />
                {/* <input type="number" name="amount" id="donation-amount" onChange={props.handleChange} value={props.values.amount} /> */}
                { ((donationForm.paramAmount && props.values.payment_type === 'Regular') || (!appeal.gift_array_active && props.values.payment_type === 'Regular')) &&
                  <p>per month</p>
                }
                <RenderError name="amount" id="donation-amount_error" {...props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricepoints;